import PerspectiveIcon from '@/components/perspectives/PerspectiveIcon';
import styled from '@emotion/styled';

const StyledPerspectiveIcon = styled(PerspectiveIcon)({
  backgroundColor: 'transparent',
  borderColor: 'transparent',
});

export default StyledPerspectiveIcon;
